import registration from './registration';

function combineActions(actions) {
  return Object.assign(
    {},
    ...actions.map(action => {
      const asyncActionConsts = Object.assign(
        {},
        ...(action.asyncConsts || []).map(constant => {
          return {
            [`${constant}`]: `${constant}`,
            [`${constant}_LOADING`]: `${constant}_LOADING`,
            [`${constant}_SUCCESS`]: `${constant}_SUCCESS`,
            [`${constant}_FAILURE`]: `${constant}_FAILURE`
          };
        })
      );

      const actionConsts = Object.assign(
        {},
        ...(action.consts || []).map(constant => ({
          [`${constant}`]: `${constant}`
        }))
      );

      const combinedActions = action.actions({
        ...asyncActionConsts,
        ...actionConsts
      });

      return Object.assign(
        {},
        asyncActionConsts,
        actionConsts,
        combinedActions
      );
    })
  );
}

const allActions = combineActions([registration]);
export default allActions;
